import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// الملفات العربية
import arNavbar from "./locales/ar/PublicPages/LayoutLanguageAr/arNavbar.json";
import arfooter from "./locales/ar/PublicPages/LayoutLanguageAr/arfooter.json"
import arHome from "./locales/ar/PublicPages/HomePage/home.json";
import arDashboard from "./locales/ar/AdminDashboardAr/arDashboard.json";
import arProducts from "./locales/ar/PublicPages/ProductsAr/arProducts.json";
import arProduct_dialog from "./locales/ar/PublicPages/ProductsAr/arProduct_dialog.json";
import arProduct_categories_component from "./locales/ar/PublicPages/ProductsAr/arproduct_categories_component.json";
import arProduct_info from "./locales/ar/PublicPages/ProductsAr/ProductInfo/arproduct_info.json";
import arProductPageInfo from "./locales/ar/PublicPages/ProductsAr/ProductInfo/arProductPageInfo.json";
import arShareUrlDialog from "./locales/ar/PublicPages/ProductsAr/ProductInfo/arshare_url_dialog.json";
import arContactForm from "./locales/ar/PublicPages/LayoutLanguageAr/arContactForm.json"
import arPrivacyPolicy from "./locales/ar/PublicPages/arPrivacyPolicyPage.json";
import arAboutUs from "./locales/ar/PublicPages/arAboutUs.json";
import arContactUs from "./locales/ar/PublicPages/arContactUs.json";
import armake_order_page from "./locales/ar/user/armake_order_page.json";
import arPaymentMethods from "./locales/ar/user/arpayment_methods.json";
// clint
import ar_my_orders_page from "./locales/ar/Clint/ar_my_orders_page.json";
import arOrderDialog from "./locales/ar/Clint/ar_order_dialog.json";
import arAddToCartDialog from "./locales/ar/user/arAddToCartDialog.json";
import arCart from "./locales/ar/user/arCart.json";
import arMyReviews from "./locales/ar/Clint/arMyReviews.json";
// Admin Pages
import arLayoutLangNavbar from "./locales/ar/AdminDashboardAr/LayoutLangAr/arLayoutLangNavbar.json";
import arSavedProducts from "./locales/ar/PublicPages/HomePage/arSavedProducts.json";


// الملفات الإنجليزية
import enNavbar from "./locales/en/PublicPages/LayoutLanguageEN/enNavbar.json";
import enfooter from "./locales/en/PublicPages/LayoutLanguageEN/enfooter.json";
import enHome from "./locales/en/PublicPages/HomePage/home.json";
import enDashboard from "./locales/en/AdminDashboardEn/erDashboard.json";
import enProducts from "./locales/en/PublicPages/ProductsEn/erProducts.json";
import enProduct_categories_component from "./locales/en/PublicPages/ProductsEn/enproduct_categories_component.json";
import enProduct_info from "./locales/en/PublicPages/ProductsEn/ProductInfo/enproduct_info.json";
import enProductPageInfo from "./locales/en/PublicPages/ProductsEn/ProductInfo/enProductPageInfo.json";
import enShareUrlDialog from "./locales/en/PublicPages/ProductsEn/ProductInfo/enshare_url_dialog.json";
import enContactForm from "./locales/en/PublicPages/LayoutLanguageEN/enContactForm.json";
import enProduct_dialog from "./locales/en/PublicPages/ProductsEn/enProduct_dialog.json";
import enPrivacyPolicy from "./locales/en/PublicPages/erPrivacyPolicyPage.json";
import enAboutUs from "./locales/en/PublicPages/enAboutUs.json";
import enContactUs from "./locales/en/PublicPages/enContactUs.json";
import enmake_order_page from "./locales/en/user/enmake_order_page.json";
import enPaymentMethods from "./locales/en/user/enpayment_methods.json";
// clint
import en_my_orders_page from "./locales/en/Clint/en_my_orders_page.json";
import enOrderDialog from "./locales/en/Clint/en_order_dialog.json";  
import enAddToCartDialog from "./locales/en/user/enAddToCartDialog.json";
import enCart from "./locales/en/user/enCart.json";
import enMyReviews from "./locales/en/Clint/enMyReviews.json";
// Admin Pages
import enLayoutLangNavbar from "./locales/en/AdminDashboardEn/LayoutLangEn/enLayoutLangNavbar.json";
import enSavedProducts from "./locales/en/PublicPages/HomePage/enSavedProducts.json";


// اللغة المحفوظة
const savedLang = localStorage.getItem("lang") || "en";

i18n.use(initReactI18next).init({
  resources: {
    ar: {
      // Public pages
      navbar: arNavbar,
      footer: arfooter, 
      ContactForm: arContactForm,
      make_order_page: armake_order_page,
      payment_methods: arPaymentMethods,
      // clint
      MyOrdersPage : ar_my_orders_page,
      MyReviews: arMyReviews,
      order_dialog: arOrderDialog,
      AddToCartDialog: arAddToCartDialog,
      cart: arCart,

      home: arHome,
      dashboard: arDashboard,
      products: arProducts,
      product_dialog: arProduct_dialog,
      product_categories_component: arProduct_categories_component,
      product_info: arProduct_info,
      product_page_info: arProductPageInfo,
      share_url_dialog: arShareUrlDialog,

      privacy_policy:arPrivacyPolicy,
      about_us: arAboutUs,
      contact_us: arContactUs,

      // Admin Pages
      admin_layout_navbar: arLayoutLangNavbar,
      saved_products: arSavedProducts,
    },
    

    // english
    en: {
      // Public pages
      navbar: enNavbar,
      footer: enfooter,
      ContactForm: enContactForm,
      make_order_page: enmake_order_page,
      payment_methods: enPaymentMethods,
      // clint
      MyOrdersPage : en_my_orders_page,
      order_dialog: enOrderDialog,
      AddToCartDialog: enAddToCartDialog,
      cart: enCart,
      MyReviews: enMyReviews,

      home: enHome,
      dashboard: enDashboard,
      products: enProducts,
      product_dialog: enProduct_dialog,
      product_categories_component: enProduct_categories_component,
      product_info: enProduct_info,
      product_page_info: enProductPageInfo,
      share_url_dialog: enShareUrlDialog,

      privacy_policy:enPrivacyPolicy,
      about_us: enAboutUs,
      contact_us: enContactUs,

       // Admin Pages
      admin_layout_navbar: enLayoutLangNavbar,
      saved_products: enSavedProducts,
    },
  },


  lng: savedLang,
  fallbackLng: "en",
  ns: ["navbar",
     "footer",
     "home", "dashboard", 
       "ContactForm",
      "products",
      "product_dialog",
      "product_categories_component",
      "product_info",
      "product_page_info",
      "share_url_dialog",

    "admin_layout_navbar",
     "cart",
     "saved_products", 
     "make_order_page",
     "payment_methods",
      "MyOrdersPage",
      "order_dialog",
      "AddToCartDialog",
      "cart",
       "MyReviews",

     "privacy_policy",
     "about_us",
     "contact_us"], // namespaces
  defaultNS: "navbar",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
